module.exports = __webpack_public_path__ + "static/media/jeremy_wacksman.5fcd3ad6.png";